import { render, staticRenderFns } from "./ProjectMainView.vue?vue&type=template&id=5ac83222"
import script from "./ProjectMainView.vue?vue&type=script&lang=js"
export * from "./ProjectMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports